/* global SunergoPlatform,A11yDialog */

const initScroll = function(gallery) {
	const visible = {
		start: false,
		end: false
	};
	const buffer = 100;
	const scrollAmount = window.innerWidth / 3;
	const actionScrollStart = gallery.parentNode.querySelector(
		'[data-action="sp-gallery-scroll-left"]'
	);
	const actionScrollEnd = gallery.parentNode.querySelector(
		'[data-action="sp-gallery-scroll-right"]'
	);

	if (actionScrollStart && actionScrollEnd) {
		actionScrollStart.addEventListener('click', function() {
			gallery.scroll(gallery.scrollLeft - scrollAmount, 0);
		});

		actionScrollEnd.addEventListener('click', function() {
			gallery.scroll(gallery.scrollLeft + scrollAmount, 0);
		});

		const checkScrollLocation = function(initial) {
			const location = gallery.scrollLeft;
			if (location <= buffer && (visible.start || initial)) {
				visible.start = false;
				actionScrollStart.hidden = true;
			} else if (location > buffer && (!visible.start || initial)) {
				visible.start = true;
				actionScrollStart.hidden = false;
			}

			if (
				location >= gallery.scrollWidth - gallery.clientWidth - buffer &&
				(visible.end || initial)
			) {
				visible.end = false;
				actionScrollEnd.hidden = true;
			} else if (
				location < gallery.scrollWidth - gallery.clientWidth - buffer &&
				(!visible.end || initial)
			) {
				visible.end = true;
				actionScrollEnd.hidden = false;
			}
		};

		checkScrollLocation(true);
		gallery.addEventListener('scroll', checkScrollLocation);
	}
};

/**
 * Initializes lightbox on gallery.
 * @param {HTMLElement} gallery - gallery element.
 * @returns early if no lightbox dialog found.
 */
const initLightbox = function(gallery) {
	const dialogContainer = document.getElementById(`dialog_${gallery.dataset.lightbox}`);
	const lightboxContainer = dialogContainer.querySelector('[data-lightbox-container]');
	if (!dialogContainer || !lightboxContainer) return;

	let loadingMessage = lightboxContainer.querySelector('[data-lightbox-loading]');
	if (loadingMessage) loadingMessage = loadingMessage.cloneNode(true);

	const dialog = new A11yDialog(dialogContainer);

	const galleryItems = document.querySelectorAll('[data-gallery-item]');
	if (!galleryItems || galleryItems.length < 1) return;

	const lightboxItems = {};
	let currentLightboxId = 0;

	const switchLightboxItem = next => {
		const numItems = Object.keys(lightboxItems).length;
		let id = next ? currentLightboxId + 1 : currentLightboxId - 1;
		const index = Object.keys(lightboxItems).findIndex(key => key == id);

		if (index < 0) {
			if (currentLightboxId == 0) id = numItems - 1;
			else id = 0;
		}

		openLightboxItem(Object.keys(lightboxItems)[id]);
	};

	const actionNextImage = dialogContainer.querySelector('[data-action="sp-gallery-lightbox-next"]');
	if (actionNextImage) actionNextImage.addEventListener('click', () => switchLightboxItem(true));

	const actionPrevImage = dialogContainer.querySelector('[data-action="sp-gallery-lightbox-prev"]');
	if (actionPrevImage) actionPrevImage.addEventListener('click', () => switchLightboxItem(false));

	const openLightboxItem = id => {
		lightboxContainer.innerHTML = '';

		const item = lightboxItems[id];
		if (!item) return;
		lightboxContainer.appendChild(item.image);
		if (item.caption) lightboxContainer.appendChild(item.caption);

		// Show dialog and add a closing action.
		dialog.show();

		const isElementTarget = (target, element) => {
			return element ? target === element || element.contains(target) : false;
		};

		const closeDialogFromBox = function(e) {
			// If the user clicks outside of the lightbox, close the dialog.
			if (
				isElementTarget(e.target, item.image)
				|| isElementTarget(e.target, item.caption)
				|| isElementTarget(e.target, actionNextImage)
				|| isElementTarget(e.target, actionPrevImage)
			) return;
			dialog.hide();
			dialogContainer.removeEventListener('click', closeDialogFromBox);
			lightboxContainer.innerHTML = '';
			currentLightboxId = 0;
		};
		dialogContainer.removeEventListener('click', closeDialogFromBox);
		dialogContainer.addEventListener('click', closeDialogFromBox);
		currentLightboxId = parseInt(id);
	};

	galleryItems.forEach((item, index) => {
		const caption = item.querySelector('figcaption');
		
		const lightboxFigure = {
			ready: false,
			image: new Image(),
			caption: caption ? caption.cloneNode(true) : false
		};

		lightboxFigure.image.onload = function() {
			lightboxFigure.image.ready = true;
		};

		// Compare image src and href. 
		// If they are different, thumbnail is being used, so we'll need to use the href instead for the full sized image.
		const thumbnailImage = item.querySelector('img');
		if (thumbnailImage && thumbnailImage.src != item.href) {
			lightboxFigure.image.classList.add('sp-gallery__image');
			lightboxFigure.image.setAttribute('alt', thumbnailImage.alt);
			lightboxFigure.image.src = item.href;
		} else if (thumbnailImage) lightboxFigure.image = thumbnailImage.cloneNode();

		lightboxItems[index] = lightboxFigure;

		item.addEventListener('click', event => {
			event.preventDefault();
			openLightboxItem(index)
		});
	});

	if (Object.keys(lightboxItems).length < 2) {
		actionNextImage.hidden = true;
		actionPrevImage.hidden = true;
	}
};

/**
 * Initializes Image Galleries.
 * @returns early if no JS needed on gallery.
 */
const initImageGalleries = function() {
	const galleries = document.querySelectorAll('[data-image-gallery]');
	if (!galleries || galleries.length < 1) return;

	Array.prototype.forEach.call(galleries, function(item) {
		const options = JSON.parse(item.dataset.imageGallery);
		if (options.indexOf('scroll') > -1) initScroll(item);
		if (options.indexOf('lightbox') > -1) initLightbox(item);
	});
};

SunergoPlatform.onLoad.push(initImageGalleries);
